import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, CSSProperties } from 'react';
import { isNumber } from 'remeda';
export const useSizeToPx = size => {
  const $ = _c(3);
  const [pixels, setPixels] = useState(isNumber(size) ? size : undefined);
  let t0;
  let t1;
  if ($[0] !== size) {
    t0 = () => {
      if (size == null || isNumber(size)) {
        return;
      }
      const div = document.createElement("div");
      div.style.visibility = "hidden";
      div.style.height = size;
      document.body.appendChild(div);
      const computedSize = window.getComputedStyle(div).height;
      setPixels(parseFloat(computedSize));
      document.body.removeChild(div);
    };
    t1 = [size];
    $[0] = size;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return pixels;
};